import service from '@/api/interactionCategory';
import {handleError} from '@/state/generators/helpers';
/*const _ = require("lodash");*/

export const state = {
    loading: false,
    interactions: {},
    service: service(),
}

export const getters = {
    loading: function (state) {
        return !!state.loading
    },
    interactions: (state) => (categoryId) => {
        if (! state.interactions[categoryId]) {
            return [];
        }

        return JSON.parse(JSON.stringify(state.interactions[categoryId]));
    }
}

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean
    },

    'SET_CATEGORY_INTERACTIONS': function (state, {id, items = []}) {
        state.interactions[id] = items;
    },
}

export const actions = {
    interactions: function ({commit, state}, categoryId) {
        commit('app/SET_LOADING', true, {root: true});
        commit('SET_LOADING', true);

        return state.service.interactions({category_id: categoryId}).then(response => {
            commit('SET_CATEGORY_INTERACTIONS', {id: categoryId, items: response.data});
            commit('app/SET_LOADING', false, {root: true});
            commit('SET_LOADING', false);
            return response.data;
        }).catch((e) => {
            handleError(e, commit)
        })
    }
}
